interface DashboardHeaderProps {
  storeLabel: string | undefined
  onLogout: () => void
}

// Figma 10715:55851 — barre de titre 2028 × 70, fond #F0EDE2, rayon 24.
export function DashboardHeader({ storeLabel, onLogout }: DashboardHeaderProps) {
  return (
    <header className="flex h-[70px] shrink-0 items-center gap-[16px] rounded-[24px] border border-[#0000000F] bg-[#F0EDE2] px-[17px]">
      <h1 className="min-w-0 flex-1 truncate font-brand text-[32px] leading-[36px] font-extrabold text-[#072C1A]">
        Dashboard {storeLabel ?? '—'}
      </h1>

      <div className="flex shrink-0 items-center gap-[10px]">
        <div className="flex flex-col items-end">
          <span className="font-sans text-[16px] leading-[18px] font-semibold text-[#072C1A]">
            {storeLabel ?? '—'}
          </span>
          <span className="font-sans text-[14px] leading-[16px] font-semibold text-[#9CA3AF]">
            Lucie Ultrafrais
          </span>
        </div>
        {/* La maquette pose une photo de boutique ici ; on garde la pastille pleine tant qu'aucune
            image de boutique n'est disponible côté API. */}
        <button
          type="button"
          onClick={onLogout}
          aria-label="Se déconnecter"
          className="size-[38px] shrink-0 cursor-pointer rounded-full bg-[#507247]"
        />
      </div>
    </header>
  )
}
